import { Component, Input, OnInit } from '@angular/core';
import { OfferCoverageDestiny } from '../../../../../../core/models/offer/offer-coverage-destiny.model';
import { LanguageService } from '../../../../../services/language.service';
import { OfferCoverageDestinyOption } from '../../../../../../core/models/offer/offer-coverage-destiny-option.model';
import { isNullOrUndefined } from 'util';
import {OfferCoverageCode} from '../../../../../../core/consts/offer-coverages/offer-coverage-code.enum';

@Component({
  selector: 'app-offer-basic-box',
  templateUrl: './offer-basic-box.component.html',
  styleUrls: ['./offer-basic-box.component.scss']
})
export class OfferBasicBoxComponent implements OnInit {
  @Input() box: OfferCoverageDestiny;
  @Input() coverageCode: OfferCoverageCode | string;

  label = '';
  optionValue = '';
  selectedOption: OfferCoverageDestinyOption = null;

  constructor(private languageService: LanguageService) {
  }

  ngOnInit() {
  }

  protected setLabel() {
    this.label = this.createLabel(this.box.labels);
  }

  protected setOptionValue() {
    if (this.selectedOption) {
      this.optionValue = this.getSelectedOptionTranslation(this.selectedOption.values);

      // FIXME - obecnie tylko dla AC_VALUE_OF_VEHICLE aby sprawdzić kiedy jeszcze nie przyjdzie wartość, po testach usunąć drugą część warunku
      if (isNullOrUndefined(this.optionValue) && this.coverageCode === OfferCoverageCode.AC_VALUE_OF_VEHICLE) {
        this.optionValue = this.languageService.translateService.instant('OFFER_SECTION.COMPARE.noInformation');
      }
    }
  }

  protected setSelectedOption(): void {
    if (this.box) {
      this.selectedOption = this.box.options.filter(({ code }) => code === this.box.selectedOption)[0];
    }
  }

  private createLabel(labels: any[]): string {
    return this.languageService.getLabel(labels);
  }

  private getSelectedOptionTranslation(options: any[]): string {
    return this.languageService.getTranslationForKey(options, 'value');
  }
}
